//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* eslint-disable import/first */
// eslint-disable-next-line
require("./Languages/" + i18n.locale);
import Vue from "vue";
// eslint-disable-next-line
import FroalaEditor from "froala-editor";
import Tribute from "tributejs";
import { i18n } from "@/i18n/index";
import VueFroala from "@/assets/js/custom_libs/froala/vue-froala";
import { config } from "./FroalaConfig";
import { uid } from "quasar";
import ConditionalBlockModal from "./ConditionalBlock/ConditionalBlockModal.vue";
import RepeatableBlockModal from "./RepeatableBlock/RepeatableBlockModal.vue";
import RichTextBlockModal from "./RichText/RichTextBlockModal.vue";
// eslint-disable-next-line
import "froala-editor/css/froala_editor.pkgd.min.css";
import "./DateFormat/DateFormatPlugin.css";
import "./ConditionalBlock/ConditionalBlockPlugin.css";
import "./RepeatableBlock/RepeatableBlockPlugin.css";
import "./RichText/RichTextBlockPlugin.css";
// eslint-disable-next-line
import "froala-editor/js/plugins.pkgd.min";
import { addDataTable, formatDataModelVar } from "./DatamodelTable";
import QAuModelPicker from "../../Generics/ModelPicker/qAuModelPicker.vue";
import { defaultDocument, defaultSelectedBlock, defaultSelectedRepeatableBlock, defaultFonts, defaultPagesState } from "./defaultDocument";

Vue.use(VueFroala);

let froalaInstance = null;
let vueInstance = null;
const tributeInterface = {
    showVariables: false
};

function changeFilter(newVal) {
    tributeInterface.showVariables = tribute.isActive;
    vueInstance.datamodelFilter = newVal;
}

const tribute = new Tribute({
    trigger: "$",
    containerClass: "tribute-menu",
    spaceSelectsMatch: false,
    allowSpaces: false,
    requireLeadingSpace: true,
    selectTemplate() {
        return "";
    },
    values(text) {
        changeFilter(text);
    },
    searchOpts: {
        pre: "",
        post: "",
        skip: true // true will skip local search, useful if doing server-side search
    }
});

export default {
    name: "Wysiwyg",
    components: {
        QAuModelPicker,
        ConditionalBlockModal,
        RepeatableBlockModal,
        RichTextBlockModal
    },
    props: {
        document: {
            type: Array,
            default: () => [defaultDocument()]
        },
        rules: {
            type: Object,
            default: () => ({})
        },
        readonly: {
            type: Boolean,
            default: false
        },
        forceUpdatePicker: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            transitionValue: false,
            selectedBlock: defaultSelectedBlock(),
            selectedRepeatableBlock: defaultSelectedRepeatableBlock(),
            showModal: false,
            showRepeatableModal: false,
            fonts: defaultFonts(),
            tableTop: 0,
            tableLeft: 0,
            richTop: 0,
            richLeft: 0,
            offsetY: 0,
            offsetX: 0,
            dataModelTop: 0,
            dataModelLeft: 0,
            tablePickerOpen: false,
            richtextPickerOpen: false,
            dataModelPickerOpen: false,
            tributeInterface,
            showVariables: false,
            filterRepeatable: [],
            showDateMenu: false,
            datamodelFilter: "",
            disableSelection: false,
            pageFormat: "",
            availableFormats: ["a4", "a3"],
            pagesState: defaultPagesState(),
            documentPagesProp: defaultDocument().pages,
            editMode: "template",
            showBlocks: false,
            textDirections: ["ltr", "rtl"],
            currentBeforeBlur: null,
            editable: false,
            basePath: "",
            dataModelConstraint: "",
            richTextOnly: { string: true, date: true, time: true, datetime: true, integer: true, boolean: true, decimal: true, user: true, list: true, attachment: true, simpleList: true, embed: true, isReference: true, isEmbeded: true },
            richTextSettings: {},
            showRichTextModal: false,
            disableButton: {
                repeatableBlock: false,
                conditionalBlock: false
            },
            config: {
                ...config,
                events: {
                    initialized() {
                        froalaInstance = this;
                        this.vueInstance = vueInstance;
                        tribute.attach(this.el);
                        this.edit.off();
                        this.toolbar.disable();
                        this.events.on(
                            "keydown",
                            // eslint-disable-next-line
                            ev => {
                                if (tribute.isActive) {
                                    vueInstance.currentBeforeBlur = tribute.current;
                                    tributeInterface.showVariables = true;
                                } else {
                                    tributeInterface.showVariables = false;
                                }
                            },
                            false
                        );
                        this.createExtraElements = function() {
                            const dummyBg = document.createElement("div");
                            dummyBg.setAttribute("class", "dummy-page");
                            this.$wp.append(dummyBg);

                            const tabs = document.createElement("div");
                            const firstPageTab = document.createElement("div");
                            firstPageTab.innerHTML = this.vueInstance.$t("froala.firstPageTab");
                            firstPageTab.setAttribute("class", "fp-tab");
                            this.$(tabs).append(firstPageTab);
                            const otherPagesTab = document.createElement("div");
                            otherPagesTab.innerHTML = this.vueInstance.$t("froala.otherPagesTab");
                            otherPagesTab.setAttribute("class", "op-tab");
                            this.$(tabs).append(otherPagesTab);
                            firstPageTab.addEventListener("click", () => {
                                this.vueInstance.setSelectedTab("first");
                            });
                            otherPagesTab.addEventListener("click", () => {
                                this.vueInstance.setSelectedTab("general");
                            });
                            tabs.setAttribute("class", "hf-tabs");
                            this.$wp.append(tabs);

                            const headTag = document.createElement("div");
                            headTag.setAttribute("class", "hf-tag head-tag");
                            headTag.addEventListener("click", () => {
                                if (this.vueInstance.editMode !== "header") {
                                    this.vueInstance.changeMode("header");
                                }
                            });
                            const text1 = document.createElement("span");
                            text1.innerHTML = this.vueInstance.$t("froala.header");
                            this.$(headTag).append(text1);
                            this.$wp.append(headTag);
                            const footTag = document.createElement("div");
                            footTag.setAttribute("class", "hf-tag foot-tag");
                            footTag.addEventListener("click", () => {
                                if (this.vueInstance.editMode !== "footer") {
                                    this.vueInstance.changeMode("footer");
                                }
                            });
                            const text2 = document.createElement("span");
                            text2.innerHTML = this.vueInstance.$t("froala.footer");
                            this.$(footTag).append(text2);
                            this.$wp.prepend(headTag);
                            this.$wp.append(footTag);

                            const tbRow = document.createElement("div");
                            tbRow.setAttribute("class", "tb-options");
                            let btns = this.button.buildList(["firstPage", "insertPageNumber", "insertPageCount"]);
                            tbRow.innerHTML = btns;

                            btns = this.$(tbRow).children("button");
                            btns.each(index => {
                                this.button.addButtons(this.$(btns[index]));
                            });
                            this.$tb.append(tbRow);
                            this.$wp[0].addEventListener("mousedown", ev => {
                                if (ev.target === this.$wp[0] && this.vueInstance.editMode !== "template") {
                                    this.vueInstance.changeMode("template");
                                }
                            });
                            this.$el[0].addEventListener("mousedown", () => {
                                if (this.vueInstance.editMode === "backgroundImage") {
                                    if (!this.vueInstance.hasBgImage) {
                                        setTimeout(() => {
                                            this.image.showInsertPopup();
                                        }, 0);
                                    }
                                }
                            });
                            const toolbarOverlay = document.createElement("div");
                            const documentOverlay = document.createElement("div");
                            toolbarOverlay.setAttribute("class", "tb-overlay");
                            documentOverlay.setAttribute("class", "doc-overlay");
                            this.$wp.append(documentOverlay);
                            this.$tb.append(toolbarOverlay);
                            this.setOverlayHeight = function() {
                                const height = this.$el.height();
                                this.$(documentOverlay).css("height", height + 40);
                            };
                            const resizeObserver = new ResizeObserver(() => {
                                this.setOverlayHeight();
                            });
                            resizeObserver.observe(this.$el[0]);
                            this.$el[0].addEventListener(
                                "keydown",
                                ev => {
                                    if (
                                        tribute.isActive &&
                                        (ev.which === 13 || // enter
                                        ev.which === 37 || // arrow left
                                        ev.which === 38 || // arrow up
                                        ev.which === 39 || // arrow right
                                            ev.which === 40) // arrow down
                                    ) {
                                        ev.stopPropagation();
                                        ev.preventDefault();
                                        vueInstance.$refs.DMPicker.$refs.modelTree.keyPress(ev);
                                        return false;
                                    }
                                },
                                true
                            );
                        };
                        this.createExtraElements();
                        vueInstance.focusEditor();
                    },
                    keyup(ev) {
                        if (
                            ev.which === 8 || // backspace
                            ev.which === 46
                        ) {
                            // delete
                            this.events.trigger("contentChanged");
                        }
                    },
                    input() {
                        this.events.trigger("contentChanged");
                    },
                    blur() {
                        this.selection.save();
                        vueInstance.currentBeforeBlur = tribute.current;
                    },
                    "edit.on": function() {
                        if (vueInstance.readonly || vueInstance.editMode === "backgroundImage") {
                            this.edit.off();
                            if (this.toolbar) {
                                this.toolbar.disable();
                            }
                        }
                    },
                    "edit.off": function() {
                        if (vueInstance.editMode === "backgroundImage") {
                            setTimeout(() => {
                                this.$tb
                                    .find('[id*="backgroundImage"]')
                                    .removeClass("fr-disabled")
                                    .addClass("fr-active");
                            }, 0);
                        }
                    },
                    focus() {
                        tribute.isActive = false;
                        tributeInterface.showVariables = false;
                    },
                    contentChanged(fromBlock) {
                        if (vueInstance.editMode === "header" || vueInstance.editMode === "footer") {
                            const contentHeight = this.$el.height();
                            vueInstance.setContentHeight(contentHeight);
                        }
                        if (tribute.isActive) {
                            this.selection.save();
                            vueInstance.currentBeforeBlur = tribute.current;
                            tributeInterface.showVariables = true;
                        } else {
                            tributeInterface.showVariables = false;
                        }
                        if (!fromBlock) {
                            this.events.focus();
                        }
                    },
                    updateRepeatableBlock(name, uid, parentUuid) {
                        vueInstance.selectedRepeatableBlock = vueInstance.getCurrentRepeatable(uid) || {
                            name,
                            uid,
                            parentUuid,
                            selection: [],
                            sortBy: "",
                            direction: "",
                            statement: "",
                            conditions: []
                        };
                        vueInstance.filterRepeatable = [...vueInstance.selectedRepeatableBlock.selection];
                    },
                    click(clickEvent) {
                        const $target = this.$(clickEvent.target);
                        if (vueInstance.editMode === "template") {
                            if ($target.parentsUntil(this.$el, "table").length > 0) {
                                vueInstance.disableButton.repeatableBlock = true;
                            } else if (!vueInstance.readonly && !$target.hasClass("fr-tribute") && !$target.hasClass("DML") && !$target.hasClass("VAR")) {
                                vueInstance.disableButton.repeatableBlock = false;
                            }
                            if (
                                !$target.hasClass("conditional-block") &&
                                ($target.hasClass("repeatable-block") || $target.parentsUntil(".fr-view, .conditional-block", ".repeatable-block").length > 0)
                            ) {
                                this.repeatableBlockPlugin.showPopup(clickEvent);
                                this.repeatableBlockPlugin.setVisible();
                                this.repeatableBlockPlugin.clickBlock(clickEvent);
                                if ($target.hasClass("repeatable-block")) {
                                    vueInstance.filterRepeatable = [];
                                }
                                if (vueInstance.selectedRepeatableBlock.selection[0]) {
                                    vueInstance.basePath = `m_${vueInstance.selectedRepeatableBlock.selection[0]}`;
                                } else {
                                    vueInstance.basePath = "";
                                }
                                this.toolbar.enable();
                            } else {
                                vueInstance.selectedRepeatableBlock = {
                                    name: "",
                                    uuid: "",
                                    parentUuid: "",
                                    selection: [],
                                    sortBy: "",
                                    direction: "",
                                    statement: "",
                                    conditions: []
                                };
                                vueInstance.filterRepeatable = [];
                                vueInstance.basePath = "";
                            }
                        }
                        if (
                            !$target.hasClass("repeatable-block") &&
                            ($target.hasClass("conditional-block") || $target.parentsUntil(".fr-view, .repeatable-block", ".conditional-block").length > 0)
                        ) {
                            this.conditionalBlockPlugin.showPopup(clickEvent);
                            this.toolbar.enable();
                        }
                        if ($target.hasClass("rich-text-block") || $target.parent().hasClass("rich-text-block")) {
                            let el = $target;
                            if (!el.hasClass("rich-text-block")) {
                                el = el.parent();
                            }
                            this.richTextBlockPlugin.showPopup(el);
                            this.richTextBlockPlugin.setVisible();
                            setTimeout(() => {
                                this.$tb.find('.fr-btn-grp.fr-float-left')
                                .eq(2)
                                .find('button[id*="conditionalBlock"], button[id*="repeatableBlock"], button[id*="dynamicTable"], button[id*="richTextBlock"]')
                                .addClass("fr-disabled");
                            }, 100);
                        } else if ($target.hasClass("fr-tribute") || $target.parent().hasClass("fr-tribute")) {
                            if (this.selection.get().type === "Range") {
                                this.toolbar.enable();
                            } else {
                                setTimeout(() => {
                                    this.fromatDatePlugin.showPopup();
                                    this.$tb.find('.fr-btn-grp.fr-float-left').eq(2).find('button').addClass("fr-disabled");
                                }, 0);
                            }
                        } else {
                            this.$tb.find('.fr-btn-grp.fr-float-left').eq(2).find('button').removeClass("fr-disabled");
                        }
                        if (
                            !$target.hasClass("repeatable-block") &&
                            ($target.hasClass("conditional-block") || $target.parentsUntil(".fr-view, .repeatable-block", ".conditional-block").length > 0)
                        ) {
                            setTimeout(() => {
                                this.conditionalBlockPlugin.setVisible();
                            }, 0);
                        }
                        if (
                            this.$el
                                .children()
                                .last()
                                .is(".conditional-block, .repeatable-block") ||
                            this.$el
                                .children()
                                .last()
                                .children()
                                .last()
                                .is(".conditional-block, .repeatable-block")
                        ) {
                            this.$el.append("<p><br></p>");
                        }
                        tribute.isActive = false;
                        tributeInterface.showVariables = false;
                        vueInstance.tablePickerOpen = false;
                        vueInstance.dataModelPickerOpen = false;
                        vueInstance.richtextPickerOpen = false;
                    },
                    "commands.mousedown": function(btn) {
                        if (btn[0].id.indexOf("dynamicTable") === -1) {
                            vueInstance.tablePickerOpen = false;
                        }
                        if (btn[0].id.indexOf("richTextBlock") === -1) {
                            vueInstance.richtextPickerOpen = false;
                        }
                        if (btn[0].id.indexOf("dataModel") === -1) {
                            vueInstance.dataModelPickerOpen = false;
                        }
                    },
                    "commands.before": function(cmd) {
                        if (vueInstance.editMode === "backgroundImage") {
                            if (!cmd.includes("image") && cmd !== "backgroundImage") {
                                return false;
                            }
                        }
                        let $selectionInBLock = this.$(this.selection.element());
                        if (!$selectionInBLock.hasClass("conditional-block")) {
                            $selectionInBLock = $selectionInBLock.parentsUntil(this.$el, ".conditional-block");
                        }
                        if ($selectionInBLock.length) {
                            $selectionInBLock.addClass("setEditableFalse").removeAttr("contenteditable");
                        }
                        return true;
                    },
                    "commands.after": function(cmd) {
                        if (cmd === "imageSetSize") {
                            if (vueInstance.editMode === "backgroundImage") {
                                const img = this.image.get();
                                vueInstance.setBgSize(img.css("width"), img.css("height"));
                                this.events.trigger("contentChanged");
                            }
                        } else if (cmd === "tableRemove") {
                            vueInstance.disableButton.repeatableBlock = false;
                        }
                        this.$el
                            .find(".setEditableFalse")
                            .attr("contenteditable", "false")
                            .removeClass("setEditableFalse");
                    },
                    "table.inserted": function(table) {
                        let newTable = table;
                        this.$(newTable).addClass("fr-collapsed-borders");
                        vueInstance.disableButton.repeatableBlock = true;
                        const blockParents = this.$(newTable).parentsUntil(this.$el, ".conditional-block");
                        const firstBlockParent = blockParents.first();
                        if (firstBlockParent.length && !firstBlockParent.hasClass("blkel")) {
                            newTable = this.$(newTable);
                            newTable.wrap('<div style="display: block" contenteditable="true" class="conditional-inner"></div>');
                            const sections = firstBlockParent.find(".conditional-inner");
                            const { $ } = this;
                            let $firstChild = null;
                            sections.each(function(index) {
                                const $this = $(this);
                                if (index === 0) {
                                    $firstChild = $this;
                                } else {
                                    $firstChild.append($this.html());
                                    $this.remove();
                                }
                            });
                        }
                    },
                    "image.inserted": function($img, resp) {
                        const { filename, fileUUID, fileURL, local } = JSON.parse(resp);
                        $img[0].setAttribute("data-filename", filename);
                        $img[0].setAttribute("data-fileuuid", fileUUID);
                        $img[0].setAttribute("data-fileurl", fileURL);
                        $img[0].setAttribute("data-local", local);
                        $img[0].removeAttribute("filename");
                        $img[0].removeAttribute("fileuuid");
                        $img[0].removeAttribute("fileurl");
                        $img[0].removeAttribute("local");
                        if (vueInstance.editMode === "backgroundImage") {
                            $img.css({ width: "793px", height: "auto" });
                            const w = $img.css("width");
                            const h = $img.css("height");
                            vueInstance.setBgSize(w, h);
                        }
                        if (vueInstance.editMode === "header" || vueInstance.editMode === "footer") {
                            $img.css({ width: "100%", height: "auto" });
                            const w = $img[0].clientWidth;
                            const h = $img[0].clientHeight;
                            $img.width(w);
                            $img.height(h);
                        }
                        this.events.trigger("contentChanged");
                    },
                    "image.removed": function() {
                        setTimeout(() => {
                            if (this.vueInstance.editMode === "backgroundImage") {
                                if (!vueInstance.hasBgImage) {
                                    vueInstance.document[0].pages.backgroundImage = defaultDocument().pages.backgroundImage;
                                    vueInstance.document[0].pages.backgroundStyle = defaultDocument().pages.backgroundStyle;
                                    this.image.showInsertPopup();
                                }
                            }
                        }, 0);
                    },
                    "image.resizeEnd": function(img) {
                        this.events.trigger("contentChanged");
                        if (vueInstance.editMode === "backgroundImage") {
                            vueInstance.setBgSize(img.css("width"), img.css("height"));
                        }
                    },
                    "image.beforeUpload": function() {
                        if (vueInstance.editMode === "backgroundImage") {
                            vueInstance.document[0].pages.backgroundImage = defaultDocument().pages.backgroundImage;
                            vueInstance.document[0].pages.backgroundStyle = defaultDocument().pages.backgroundStyle;
                        }
                    },
                    "popups.show.image.edit": function() {
                        if (vueInstance.editMode === "backgroundImage") {
                            setTimeout(() => {
                                this.$tb
                                    .find('[id*="backgroundImage"]')
                                    .removeClass("fr-disabled")
                                    .addClass("fr-active");
                            });
                        }
                    },
                    "popups.show.table.edit": function() {
                        if (tribute.isActive) {
                            this.popups.hide("table.edit");
                        }
                    }
                }
            }
        };
    },
    computed: {
        pickerBlackList() {
            return this.editMode === "template" ? {} : { richtext: true };
        },
        currentDoc() {
            if (this.transitionValue) {
                return {
                    template: "&nbsp;",
                    backgroundImage: "&nbsp;",
                    header: "&nbsp;",
                    footer: "&nbsp;"
                };
            }
            let result = this.document[0] || defaultDocument();
            if (this.editMode === "backgroundImage") {
                result = result.pages;
            } else if (this.editMode !== "template") {
                result = result.pages[this.pagesState[this.editMode].tab];
            }
            return result;
        },
        pagesSelectedTab() {
            return this.pagesState[this.editMode].tab;
        },
        forceUpdateState() {
            let state = this.forceUpdatePicker;
            if (this.selectedRepeatableBlock && this.selectedRepeatableBlock.selection && this.selectedRepeatableBlock.selection.length) {
                state = true;
            }
            return state;
        },
        bgImage() {
            return this.documentPagesProp.backgroundImage;
        },
        hasBgImage() {
            return this.bgImage.includes("<img");
        },
        headerValue() {
            let value = this.documentPagesProp.general.header;
            if (this.documentPagesProp.differentFirstHeader) {
                value += this.documentPagesProp.first.header;
            }
            return value;
        },
        headerEmpty() {
            return this.headerValue === "";
        },
        footerValue() {
            let value = this.documentPagesProp.general.footer;
            if (this.documentPagesProp.differentFirstFooter) {
                value += this.documentPagesProp.first.footer;
            }
            return value;
        },
        footerEmpty() {
            return this.footerValue === "";
        }
    },
    watch: {
        tributeInterface: {
            handler(newVal) {
                if (newVal.showVariables) {
                    this.refreshMenuPosition();
                    froalaInstance.events.focus();
                    setTimeout(() => {
                        froalaInstance.popups.hide("table.edit");
                    });
                }
                if (newVal.showVariables !== this.showVariables) {
                    this.showVariables = newVal.showVariables;
                    froalaInstance.events.focus();
                }
            },
            deep: true,
            immediate: true
        },
        document: {
            handler(newVal, oldVal) {
                if (newVal[0].id !== oldVal[0].id) {
                    // this in NOT useless, it forces pages object to be reactive
                    this.documentPagesProp = newVal[0].pages;
                    this.editMode = "template";
                    this.exitBgImageMode();
                    if (froalaInstance) {
                        froalaInstance.$sc.removeClass("hd-mode");
                        froalaInstance.$sc.removeClass("ft-mode");
                        if (froalaInstance.codeView.isActive()) {
                            froalaInstance.codeView.toggle();
                        }
                    }

                    this.pagesState = defaultPagesState();
                    if (newVal[0].template === oldVal[0].template) {
                        const temp = newVal[0].template;
                        newVal[0].template = "";
                        this.$nextTick(() => {
                            newVal[0].template = temp;
                        });
                    }
                    if (newVal[0].pages.size) {
                        this.pageFormat = newVal[0].pages.size;
                        froalaInstance.opts.pageFormat = newVal[0].pages.size;
                    } else {
                        newVal[0].pages.size = "a4";
                        this.pageFormat = "a4";
                        froalaInstance.opts.pageFormat = "a4";
                    }
                    if (!newVal[0].pages.backgroundImage) {
                        newVal[0].pages.backgroundImage = defaultDocument().pages.backgroundImage;
                    }
                    if (!newVal[0].pages.backgroundStyle) {
                        newVal[0].pages.backgroundStyle = defaultDocument().pages.backgroundStyle;
                    }
                    if (newVal[0].pages) {
                        this.pagesState.header.differentFirstPage = newVal[0].pages.differentFirstHeader;
                        this.pagesState.footer.differentFirstPage = newVal[0].pages.differentFirstFooter;
                    }
                    froalaInstance.selection.clear();
                    froalaInstance.selection.remove();
                }
                if (newVal.length === 0 || (newVal[0].processDefinitionId === null && newVal[0].name === null && newVal[0].id === null)) {
                    this.editable = false;
                } else {
                    this.editable = true;
                    if (froalaInstance !== null) {
                        froalaInstance.opts.imageUploadURL = `/documents/templates/${newVal[0].id}/image/upload/`;
                        this.documentPagesProp = newVal[0].pages;
                    }
                }
            },
            deep: true
        },
        readonly: {
            handler(newVal) {
                if (newVal) {
                    this.editable = false;
                } else {
                    this.editable = true;
                    this.focusEditor();
                }
            },
            immediate: true
        },
        editable: {
            handler() {
                if (froalaInstance) {
                    froalaInstance.edit.on();
                    froalaInstance.$tb
                        .find('[id*="downloadPreviewPDF"]')
                        .removeClass("fr-disabled")
                        .addClass("fr-active");
                    froalaInstance.$tb
                        .find('[id*="downloadPreviewDOCX"]')
                        .removeClass("fr-disabled")
                        .addClass("fr-active");    
                }
            }
        }
    },
    created() {
        this.closePickers();
        let { host } = window.location;
        let { protocol } = window.location;

        if (host.indexOf("localhost") !== -1) {
            host = process.env.VUE_APP_ENV_PATH;
            protocol = "https:";
        }
        this.fonts = this.fonts.map(element => `${protocol}//${host}/fonts/${element}/${element}.css`);
    },

    activated() {
        this.registerCommands();
        this.closePickers();
        this.editMode = "template";
        this.exitBgImageMode();
        if (froalaInstance) {
            froalaInstance.$sc.removeClass("hd-mode");
            froalaInstance.$sc.removeClass("ft-mode");
        }
    },
    deactivated() {
        this.closePickers();
        this.editMode = "template";
        this.exitBgImageMode();
        this.documentPagesProp = defaultDocument().pages;
        if (froalaInstance) {
            froalaInstance.$sc.removeClass("hd-mode");
            froalaInstance.$sc.removeClass("ft-mode");
        }
    },
    methods: {
        closePickers() {
            this.tablePickerOpen = false;
            this.richtextPickerOpen = false;
            this.dataModelPickerOpen = false;
            this.showVariables = false;
        },
        getdataModelConstraint() {
            this.dataModelConstraint = "";
            const parent = this.document[0].repeatableParameters.filter(el => el.uuid === this.selectedRepeatableBlock.parentUuid);
            if (parent.length) {
                [this.dataModelConstraint] = parent[0].selection;
            }
        },
        registerCommands() {
            vueInstance = this;
            FroalaEditor.RegisterCommand("dynamicTable", {
                title: vueInstance.$t("froala.dynamicTableTooltip"),
                focus: true,
                undo: false,
                refreshAfterCallback: true,
                callback: () => {
                    if (!this.tableTop && !this.tableLeft) {
                        return;
                    }
                    froalaInstance.selection.save();
                    this.tablePickerOpen = !this.tablePickerOpen;
                    if (tribute.isActive) {
                        this.showVariables = false;
                        tribute.isActive = false;
                        tributeInterface.showVariables = false;
                    }
                },
                refresh: $btn => {
                    if (this.editMode !== "template") {
                        $btn.addClass("fr-disabled");
                    } else {
                        $btn.removeClass("fr-disabled");
                    }
                    this.tableTop = $btn[0].getBoundingClientRect().top + 50;
                    this.tableLeft = $btn[0].getBoundingClientRect().left;
                },
                refreshOnShow: $btn => {
                    this.tableTop = $btn[0].getBoundingClientRect().top + 50;
                    this.tableLeft = $btn[0].getBoundingClientRect().left;
                }
            });
            FroalaEditor.RegisterCommand("richTextBlock", {
                title: i18n.t("froala.richTextBlockTooltip"),
                focus: true,
                undo: true,
                refreshAfterCallback: true,
                callback: () => {
                    froalaInstance.selection.save();
                    this.richtextPickerOpen = !this.richtextPickerOpen;
                    if (tribute.isActive) {
                        this.showVariables = false;
                        tribute.isActive = false;
                        tributeInterface.showVariables = false;
                    }
                },
                refresh: $btn => {
                    if (this.editMode !== "template" && !this.configNotifications) {
                        $btn.addClass("fr-disabled");
                    } else {
                        $btn.removeClass("fr-disabled");
                    }
                    this.richTop = $btn[0].getBoundingClientRect().top + 50;
                    this.richLeft = $btn[0].getBoundingClientRect().left;
                },
                refreshOnShow: $btn => {
                    this.richTop = $btn[0].getBoundingClientRect().top + 50;
                    this.richLeft = $btn[0].getBoundingClientRect().left;
                },
                plugin: "richTextBlockPlugin"
            });
        },
        updateBlock({ name = "", description = "", uuid = "", statement = "", conditions = [] } = {}) {
            this.selectedBlock.uuid = uuid;
            const currentRule = this.getCurrentRule(uuid);
            if (currentRule) {
                currentRule.statement = statement;
                currentRule.conditions = conditions;
                currentRule.name = name;
            } else {
                let customUid = uid();
                this.document[0].rules.push({
                    uuid: customUid,
                    statement,
                    conditions,
                    description,
                    name
                });
                uuid = customUid;
            }
            froalaInstance.conditionalBlockPlugin.applySettings({ name, uuid });
            this.showModal = false;
        },
        getCurrentRule(uuid) {
            if (!this.document[0].rules) {
                this.document[0].rules = [];
            }
            return this.document[0].rules.find(rule => rule.uuid === uuid);
        },
        getCurrentRepeatable(uuid) {
            if (!this.document[0].repeatableParameters) {
                this.document[0].repeatableParameters = [];
            }
            return this.document[0].repeatableParameters.find(elem => elem.uuid === uuid);
        },
        removeBlock(uuid) {
            this.showModal = false;
            froalaInstance.conditionalBlockPlugin.removeBlock(uuid);
            this.deleteRule(uuid);
        },
        deleteRule(uuid) {
            if (!this.document[0].rules) {
                this.document[0].rules = [];
            }
            this.document[0].rules = this.document[0].rules.filter(rule => rule.uuid !== uuid);
        },
        deleteRepeatableConfig(uuid) {
            if (!this.document[0].repeatableParameters) {
                this.document[0].repeatableParameters = [];
            }
            this.document[0].repeatableParameters = this.document[0].repeatableParameters.filter(config => config.uuid !== uuid);
        },
        getFilteredList({ name = "", uuid = "", parentUuid = "", selection = [], sortBy = "", direction = "", statement = "", conditions = [] } = {}) {
            this.selectedRepeatableBlock = {
                uuid,
                name,
                parentUuid,
                selection,
                sortBy,
                direction,
                statement,
                conditions
            };
            const repBlock = this.getCurrentRepeatable(uuid);
            if (repBlock && repBlock.uuid) {
                let currentId = uuid;
                let childBlock = this.document[0].repeatableParameters.find(el => el.parentUuid === currentId);
                if (JSON.stringify(repBlock.selection) !== JSON.stringify(selection)) {
                    while (childBlock) {
                        currentId = childBlock.uuid;
                        childBlock.selection = [];
                        childBlock.statement = "";
                        childBlock.conditions = [];
                        // eslint-disable-next-line no-loop-func
                        childBlock = this.document[0].repeatableParameters.find(el => el.parentUuid === currentId);
                    }
                }
                repBlock.name = name;
                repBlock.selection = selection;
                repBlock.sortBy = sortBy;
                repBlock.direction = direction;
                repBlock.statement = statement;
                repBlock.conditions = conditions;
            } else {
                this.document[0].repeatableParameters.push({
                    uuid,
                    name,
                    parentUuid,
                    selection,
                    sortBy,
                    direction,
                    statement,
                    conditions
                });
            }
            froalaInstance.repeatableBlockPlugin.applySettings({ name, uuid });
        },
        openBlockSettings({ name, uuid }) {
            const rule = this.getCurrentRule(uuid);
            if (rule) {
                const { description, statement, conditions } = rule;
                this.selectedBlock = {
                    name,
                    uuid,
                    description,
                    conditions: { statement, conditions }
                };
            } else {
                this.selectedBlock = {
                    name,
                    uuid,
                    description: "",
                    conditions: {
                        statement: "",
                        conditions: []
                    }
                };
            }

            this.showModal = true;
        },
        openRepeatableBlockSettings({ name, uuid, parentUuid }) {
            const repBlock = this.getCurrentRepeatable(uuid);
            if (repBlock) {
                const { selection, sortBy, direction, statement, conditions } = repBlock;
                this.selectedRepeatableBlock = {
                    name,
                    uuid,
                    parentUuid,
                    selection,
                    sortBy,
                    direction,
                    conditions: { statement, conditions }
                };
            } else {
                this.selectedRepeatableBlock = {
                    name,
                    uuid,
                    parentUuid,
                    selection: [],
                    sortBy: "",
                    direction: "",
                    conditions: {
                        statement: "",
                        conditions: []
                    }
                };
            }
            this.getdataModelConstraint();
            this.showRepeatableModal = true;
        },
        openRichTextSettings(name) {
            this.richTextSettings = { name };
            this.showRichTextModal = true;
        },
        closeRichTextSettings() {
            this.richTextSettings = {};
            this.showRichTextModal = false;
        },
        removeRichTextBlock() {
            this.showRichTextModal = false;
            froalaInstance.richTextBlockPlugin.deleteRichTextBlock();
        },
        updateRichText(ev) {
            froalaInstance.richTextBlockPlugin.applySettings(ev);
            this.showRichTextModal = false;
        },
        changeMode(mode) {
            if (mode !== this.editMode) {
                this.transitionValue = true;
            }
            if (this.editMode === "backgroundImage" && mode !== "backgroundImage") {
                this.exitBgImageMode();
            }
            if (mode !== "header") {
                froalaInstance.$sc.removeClass("hd-mode");
            }
            if (mode !== "footer") {
                froalaInstance.$sc.removeClass("ft-mode");
            }
            this.editMode = mode;
            froalaInstance.opts.differentFirstPage = this.pagesState[mode].differentFirstPage;
            this.$nextTick(() => {
                this.transitionValue = false;
            });
            if (mode === "backgroundImage") {
                return this.setBgImageMode();
            }
            if (mode === "footer") {
                froalaInstance.$sc.addClass("ft-mode");
            }
            if (mode === "header") {
                froalaInstance.$sc.addClass("hd-mode");
            }
            this.focusEditor();
        },
        setBgImageMode() {
            froalaInstance.toolbar.disable();
            froalaInstance.$sc.addClass("bg-mode");
            froalaInstance.opts.charCounterMax = 0;
            froalaInstance.$tb
                .find('[id*="backgroundImage"]')
                .removeClass("fr-disabled")
                .addClass("fr-active");
            froalaInstance.$el.blur();
            if (!this.hasBgImage) {
                froalaInstance.image.showInsertPopup();
            }
        },
        exitBgImageMode() {
            if (froalaInstance) {
                froalaInstance.popups.hideAll();
                froalaInstance.opts.charCounterMax = -1;
                froalaInstance.$sc.removeClass("bg-mode");
                froalaInstance.toolbar.enable();
            }
            this.focusEditor();
        },
        focusEditor() {
            if (froalaInstance) {
                setTimeout(() => {
                    if (this.readonly || this.editMode === "backgroundImage") {
                        return;
                    }
                    froalaInstance.edit.on();
                    froalaInstance.toolbar.enable();
                    froalaInstance.events.enableBlur();
                    froalaInstance.events.trigger("blur");
                    froalaInstance.$el.focus();
                    froalaInstance.selection.restore();
                    froalaInstance.events.disableBlur();
                }, 0);
            }
        },
        setBgSize(w, h) {
            const [{ pages } = {}] = this.document;
            const [, position, repeat] = pages.backgroundStyle.split(";");
            pages.backgroundStyle = `background-size: ${w} ${h};${position};${repeat};`;
        },
        setDifferentFirstPage(newVal) {
            const [doc] = this.document;
            if (this.editMode === "template" || this.editMode === "backgroundImage") {
                return;
            }
            if (this.editMode === "header") {
                doc.pages.differentFirstHeader = newVal;
            } else if (this.editMode === "footer") {
                doc.pages.differentFirstFooter = newVal;
            }
            this.pagesState[this.editMode].differentFirstPage = newVal;
            if (!newVal) {
                this.setSelectedTab("general");
            }
        },
        setSelectedTab(value) {
            this.pagesState[this.editMode].tab = value;
            this.focusEditor();
        },
        setContentHeight(height) {
            if (this.editMode !== "header" && this.editMode !== "footer") {
                return;
            }
            const [doc] = this.document;
            const activeTab = this.pagesState[this.editMode].tab;
            doc.pages[activeTab][`${this.editMode}Height`] = `${height}px`;
        },
        changePageLayout(newFormat) {
            const [doc] = this.document;
            this.pageFormat = newFormat;
            doc.pages.size = newFormat;
            return this.pageFormat;
        },
        toggleShowBlocks() {
            this.showBlocks = !this.showBlocks;
            return this.showBlocks;
        },
        insertTable([ev]) {
            this.tablePickerOpen = false;
            return addDataTable(ev, froalaInstance);
        },
        insertRichText(item) {
            this.richtextPickerOpen = false;
            this.onStaticSelect(item);
        },
        onModelSelect(item) {
            froalaInstance.selection.restore();
            const newElement = formatDataModelVar(item);
            if (this.currentBeforeBlur) {
                tribute.current = this.currentBeforeBlur;
            }
            tribute.range.replaceTriggerText(newElement, false, false, {}, {});
            const insertedEl = froalaInstance.$(".last-inserted");
            insertedEl.removeClass("last-inserted");
            tribute.isActive = false;
            tributeInterface.showVariables = false;
            froalaInstance.events.focus();
            froalaInstance.cursor.backspace();
            if (item.type === "richtext") {
                froalaInstance.richTextBlockPlugin.showPopup(insertedEl);
            }
        },
        onStaticSelect(item) {
            const newElement = formatDataModelVar(item);
            froalaInstance.selection.restore();
            if (item.type === "richtext") {
                froalaInstance.html.insert(newElement);
            } else {
                froalaInstance.html.insert(`${newElement}&nbsp;`);
            }
            const insertedEl = froalaInstance.$(".last-inserted");
            insertedEl[0].scrollIntoView({ behavior: "smooth", block: "center" });
            insertedEl.removeClass("last-inserted");
            froalaInstance.events.trigger("contentChanged");
            froalaInstance.cursor.backspace();
            if (item.type === "richtext") {
                froalaInstance.richTextBlockPlugin.showPopup(insertedEl);
            }
            this.dataModelPickerOpen = false;
        },
        refreshMenuPosition() {
            const menuHeight = 300;
            const menuWidth = 320;
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;
            const selectionX = froalaInstance.position.getBoundingRect().x;
            const selectionY = froalaInstance.position.getBoundingRect().y;
            this.offsetY = selectionY + 20;
            this.offsetX = selectionX;
            if (selectionY > windowHeight / 2) {
                this.offsetY = selectionY - menuHeight - 10;
            }
            if (selectionX > windowWidth / 2) {
                this.offsetX = selectionX - menuWidth;
            }
        },
        stopForceUpdate() {
            if (this.forceUpdatePicker) {
                this.$emit("pickerUpdated");
            }
        },
        downloadPreviewPDF() {
            this.$emit("downloadPreviewPDF");
            froalaInstance.$tb
                .find('[id*="downloadPreviewPDF"]')
                .removeClass("fr-disabled")
                .addClass("fr-active");
        },
        downloadPreviewDOCX() {
            this.$emit("downloadPreviewDOCX");
            froalaInstance.$tb
                .find('[id*="downloadPreviewDOCX"]')
                .removeClass("fr-disabled")
                .addClass("fr-active");
        }
    }
};
